import * as React from 'react';
import { ActionButton, fetchApi, notifyError, notifyResponse } from 'gossamer-front-end';
import { AdminInstitutionGroupMemberRemoveRequest, InstitutionGroupMember, InstitutionGroupMemberView } from 'cb-model';

export interface RemoveMemberFromGroupButtonProps {
  value: string; // institution group member id
}

export const RemoveMemberFromGroupButton: React.FC<RemoveMemberFromGroupButtonProps> = (props) => {
  return (
    <ActionButton
      label="Remove"
      size="sm"
      variant="danger"
      execute={async (resetCache) => {
        try {
          const response = await fetchApi('POST', `/main/institution-group-member-remove`, {
            institutionGroupMemberId: Number(props.value),
          } as AdminInstitutionGroupMemberRemoveRequest);
          resetCache(InstitutionGroupMember.id, props.value);
          resetCache(InstitutionGroupMemberView.id, props.value);
          notifyResponse(response);
        } catch (e) {
          notifyError(e, 'An error occurred while removing the member from the group');
        }
      }}
    />
  );
};
